import script from "./IndustryModel.vue?vue&type=script&lang=ts&setup=true"
export * from "./IndustryModel.vue?vue&type=script&lang=ts&setup=true"

import "./IndustryModel.vue?vue&type=style&index=0&id=0eec3205&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0eec3205"]])

export default __exports__